'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { comboboxInputGroupStyle } from './styles/combobox-input-group.styles';
import type { ComboboxInputGroupPropsInterface } from './types/combobox-input-group.types';

/**
 * @since 10.0.0
 */
export const ComboboxInputGroup = forwardRef<HTMLDivElement, ComboboxInputGroupPropsInterface>(
  (props: ComboboxInputGroupPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const styles = css(comboboxInputGroupStyle, cssProp);
    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Combobox.InputGroup"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

ComboboxInputGroup.displayName = 'Combobox.InputGroup';
